const selectors = {
  section: ".js-knowledge-thinking-row"
};

const KnowledgeThinkingRow = () => {
  let Slider;
  const sliderOptions = {
    grabCursor: true,
    slidesPerView: 1.2,
    breakpoints: {
      768: {
        slidesPerView: 2.2
      },
      992: {
        slidesPerView: 3.2
      }
    }
  };

  async function init(sectionId) {
    Slider = await window.themeCore.utils.getExternalUtil(
      "FeaturedContentSlider"
    );
    const sections = [...document.querySelectorAll(selectors.section)].filter(
      (section) => !sectionId || section.closest(`#shopify-section-${sectionId}`)
    );
    sections.forEach((section) => Slider(section, sliderOptions, null, true).init());
  }

  return Object.freeze({
    init
  });
};

const action = () => {
  window.themeCore.KnowledgeThinkingRow = window.themeCore.KnowledgeThinkingRow || KnowledgeThinkingRow();
  window.themeCore.utils.register(window.themeCore.KnowledgeThinkingRow, "related-articles");
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}